import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { DatePicker, Dialog, MessagePlugin, Radio } from 'tdesign-react';
import Form from '@/components/Form';

export default function FormModal({ handleClose, visible, request }) {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  const type = Form.useWatch('type', form);

  const { FormItem } = Form;

  const handleSubmit = async (values) => {
    let params = null;
    if (values.type === '2') {
      params = {
        retentionTime: dayjs(values.retentionTime).format('YYYY-MM-DD HH:mm:ss'),
      };
    }
    try {
      setSubmitting(true);
      await request(params);
      MessagePlugin.success('操作成功');
      handleClose(true);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ type: '1' });
    } else {
      form.resetFields();
    }
  }, [visible, form]);

  return (
    <Dialog
      header='请选择清理方式'
      onClose={() => handleClose()}
      visible={visible}
      confirmBtn={{ loading: submitting, content: '确定' }}
      onConfirm={() => form.submit()}
      width={550}
    >
      <Form style={{ width: '90%' }} form={form} onFinish={handleSubmit}>
        <FormItem name='type' label=''>
          <Radio.Group>
            <Radio value='1'>全部</Radio>
            <Radio value='2'>自定义</Radio>
          </Radio.Group>
        </FormItem>
        {type === '2' && (
          <FormItem name='retentionTime' label='' rules={[{ required: true }]}>
            <DatePicker enableTimePicker allowInput clearable placeholder='在此时间之前' />
          </FormItem>
        )}
      </Form>
    </Dialog>
  );
}
